import {Injectable} from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError, retry, tap} from 'rxjs/operators';
import {AuthenticationService} from '../services/authentication.service';


@Injectable()
export class ErrorInterceptorService implements HttpInterceptor {

  constructor(private authenticationService: AuthenticationService) { }
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const base$ = next.handle(request);
    const retriable$ = request.method === 'GET' ? base$.pipe(retry(1)) : base$;
    return retriable$.pipe(
        tap((event) => {
          if (event instanceof HttpResponse && event.status === 200) {
            // throwError("event.body");
            const body = event.body;
            if (body && typeof body.StatusCode !== 'undefined' && body.StatusCode > 0){
              throw new HttpErrorResponse({
                error: 'CustomError',
                headers: event.headers,
                status: event.body.StatusCode,
                statusText: event.body.StatusMessage,
                url: event.url
              });
            }
          }
        }),
        catchError(error => {
           if(error instanceof HttpErrorResponse && error.status === 401) {
              return next.handle(request);
          }
          else{
            return throwError(error);
          }
        })
      );
  }
}
